import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import Card from '../../../../molecules/Card'
import InlineCardHeader from '../../../../molecules/Card/InlineCardHeader'
import RecentLogs from '../shared/RecentLogs'

const targetType = 'catalog/datasource'

function AuditTab ({ datasource }) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Card>
          <InlineCardHeader>Recent Events</InlineCardHeader>
          <RecentLogs targetType={targetType} targetIdentifier={datasource.catalogDatasourceId} />
        </Card>
      </Grid>
    </Grid>

  )
}

AuditTab.propTypes = {
  datasource: PropTypes.any
}

export default AuditTab
